import { Wrapper } from './Dim.styled';

export default function Dim() {
  return <Wrapper></Wrapper>;
}
